var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_208811138398150634502029967163149580486",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_271710665306093688456421331661481102078",
    x1: "9.887%",
    x2: "94.686%",
    y1: "38.829%",
    y2: "61.372%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#49FFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1ADCAA"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_208811138398150634502029967163149580486)",
    d: "M10.379 13.26c1.337 0 2.36-.364 3.066-1.092.944-.892 1.415-2.179 1.415-3.859 0-1.714-.471-3-1.415-3.86-.707-.727-1.729-1.091-3.066-1.091-1.337 0-2.36.364-3.066 1.092-.948.859-1.422 2.145-1.422 3.86 0 1.68.474 2.966 1.422 3.858.707.728 1.729 1.092 3.066 1.092zm0-1.656c-.775 0-1.392-.286-1.854-.857-.46-.572-.692-1.384-.692-2.438 0-1.054.231-1.866.692-2.437.462-.572 1.08-.857 1.854-.857s1.389.286 1.844.86c.455.573.682 1.385.682 2.434 0 1.054-.227 1.866-.682 2.438-.455.57-1.07.857-1.844.857zM18.142 13V6.354L21.963 13h1.955V3.644h-1.821v6.531L18.37 3.644h-2.05V13h1.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_271710665306093688456421331661481102078)",
    d: "M26.5 1h-23C1.567 1 0 2.567 0 4.5v8C0 14.433 1.567 16 3.5 16h23c1.933 0 3.5-1.567 3.5-3.5v-8C30 2.567 28.433 1 26.5 1zm0 1C27.88 2 29 3.12 29 4.5v8c0 1.38-1.12 2.5-2.5 2.5h-23C2.12 15 1 13.88 1 12.5v-8C1 3.12 2.12 2 3.5 2h23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.a7160c6d27159981423abb5628c60db4.svg";
export { ForwardRef as ReactComponent };